import type {RemediationType} from "@ri2/db/client"

/** Preferred HashRouter base (`#/ri/...`). */
export const ROOT = "/ri"
/** Legacy HashRouter base (`#/ri2/...`) — still accepted for deep links. */
export const LEGACY_ROOT = "/ri2"

export const isRootPath = (pathname: string): boolean =>
  pathname === ROOT || pathname === LEGACY_ROOT

export const DIY_SEGMENT = "diy"
export const DIY_VIDEOS_SEGMENT = "videos"
export const DIY_DOCUMENTS_SEGMENT = "documents"
export const DIY_STEPS = "steps"

export const DIFM_SEGMENT = "difm"

export type CaseTab = "conversation" | "causes"

export type PathOptions =
  | {
      name: "cases"
    }
  | {
      name: "cases"
      caseId: string
      tab?: CaseTab
      text?: string
    }
  | {
      name: "cases"
      caseId: string
      causeOnMessageId: number | "peek"
      recommendation?: RemediationType
    }
  | {
      name: "cases"
      caseId: string
      causeOnMessageId: number | "peek"
      diy:
        | true
        | typeof DIY_STEPS
        | typeof DIY_VIDEOS_SEGMENT
        | typeof DIY_DOCUMENTS_SEGMENT
    }
  | {
      name: "cases"
      caseId: string
      causeOnMessageId: number | "peek"
      difm: true
    }

export const makePath = (options?: PathOptions): string => {
  if (!options) return ROOT

  const segments = []
  const queryParams = new URLSearchParams()

  if ("caseId" in options) {
    if ("tab" in options) {
      segments.push(`${options.caseId}?tab=${options.tab}`)
    } else if ("text" in options) {
      segments.push(`${options.caseId}?text=${options.text}`)
    } else {
      segments.push(options.caseId)
    }
  }

  if ("causeOnMessageId" in options) {
    segments.push(String(options.causeOnMessageId))
  }

  if ("recommendation" in options && options.recommendation) {
    queryParams.set("recommendation", options.recommendation)
  }

  if ("diy" in options) {
    segments.push(DIY_SEGMENT)
    if (options.diy !== true) segments.push(options.diy)
  }
  if ("difm" in options) {
    segments.push(DIFM_SEGMENT)
  }

  const path = [ROOT, ...segments].join("/")

  if (queryParams.size > 0) {
    return `${path}?${queryParams.toString()}`
  }

  return path
}
